import {
    ADD_PAYMENT_SUCCESS,
    ADD_PAYMENT_FAIL,
    DELETE_PAYMENT_SUCCESS,
    DELETE_PAYMENT_FAIL,
    GET_PAYMENT_DETAILS_FAIL,
    GET_PAYMENT_DETAILS_SUCCESS,
    GET_PAYMENT_LISTING_FAIL,
    GET_PAYMENT_LISTING_SUCCESS,
    RESET_PAYMENT_STATE,
    UPDATE_PAYMENT_CONFIGURATION_FAIL,
    UPDATE_PAYMENT_CONFIGURATION_SUCCESS,
    UPDATE_PAYMENT_FAIL,
    UPDATE_PAYMENT_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    paymentListing: [],
    paymentDetails: [],
    updatePayment: [],
    addPayment: [],
    deletePayment: [],
    updatePaymentConfiguration: [],
    error: [],
}

const Payment = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PAYMENT_LISTING_SUCCESS:
            return {
                ...state,
                paymentListing: action.payload
            }
        case GET_PAYMENT_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_PAYMENT_DETAILS_SUCCESS:
            return {
                ...state,
                paymentDetails: action.payload
            }
        case GET_PAYMENT_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }
            
        case UPDATE_PAYMENT_SUCCESS:
            return {
                ...state,
                updatePayment: action.payload
            }
        case UPDATE_PAYMENT_FAIL:
            return {
                ...state,
                error: action.payload,
            }
    
        case ADD_PAYMENT_SUCCESS:
            return {
                ...state,
                addPayment: action.payload
            }
        case ADD_PAYMENT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_PAYMENT_SUCCESS:
            return {
                ...state,
                deletePayment: action.payload
            }
        case DELETE_PAYMENT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_PAYMENT_CONFIGURATION_SUCCESS:
            return {
                ...state,
                updatePaymentConfiguration: action.payload
            }
        case UPDATE_PAYMENT_CONFIGURATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_PAYMENT_STATE:
            return {
                ...state,
                paymentListing: [],
                paymentDetails: [],
                updatePayment: [],
                addPayment: [],
                deletePayment: [],
                updatePaymentConfiguration: [],
                error: [],
            }
        default:
            return state
    }
}

export default Payment
